<div class="bg-roseNovo shadow-sm rounded-[30px] p-2 cursor-move hover:shadow-md transition-shadow duration-200">
    <div class="flex items-center justify-start gap-2">
        <mat-icon class="material-symbols-outlined text-rougeNovo" style="font-size: 24px;">description</mat-icon>
        <div class="truncate my-auto text-rougeNovo" >{{ getLocalizedName()}}</div>
    </div>
</div>
